import { ElementType, Suspense, lazy } from 'react'
import { RouteObject, useRoutes } from 'react-router-dom'
import AmeSpin from './components/AmeSpin/AmeSpin'
import { PAGE_LINKS } from './helpers/commonConsts'

const Loadable = (Component: ElementType) => (props: any) =>
  (
    <Suspense fallback={<AmeSpin fullscreen={true} />}>
      <Component {...props} />
    </Suspense>
  )

const HomePage = Loadable(lazy(() => import('./pages/HomePage/HomePage')))
const LoginPage = Loadable(lazy(() => import('./pages/LoginPage/LoginPage')))
const WxLoginPage = Loadable(lazy(() => import('./pages/WxLoginPage/WxLoginPage')))

const routes: RouteObject[] = [
  {
    path: PAGE_LINKS.home,
    element: <HomePage />,
  },
  {
    path: PAGE_LINKS.login,
    element: <LoginPage />,
  },
  {
    path: PAGE_LINKS.wxLogin,
    element: <WxLoginPage />,
  },
]

export const Router = () => {
  return useRoutes(routes)
}
